"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternRef = void 0;
const GenerationalArena_1 = require("./GenerationalArena");
const store = new GenerationalArena_1.GenerationalArena();
class ExternRef {
    static create(reference) {
        return store.allocate(reference);
    }
    static load(handle) {
        return store.retrieve(handle);
    }
    static delete(handle) {
        store.deallocate(handle);
    }
}
exports.ExternRef = ExternRef;
